module.exports = __webpack_public_path__ + "static/2-b504848bb7fa076adf28d9c0db0031b2.jpg";